import React, { Fragment } from 'react';
import { useForm } from 'react-final-form';
import {
    List, Datagrid, TextField, ReferenceField, Edit, DeleteButton, BooleanInput, BooleanField, CloneButton, AutocompleteInput, TextInput, ReferenceInput, SelectInput, ImageField, NumberInput, Pagination,
    FormDataConsumer, EditButton, required, TabbedForm, FormTab, Create, Filter, REDUX_FORM_NAME, Toolbar
} from 'react-admin';

const TrackPagination = props => <Pagination rowsPerPageOptions={[100, 50, 25, 10]} {...props} />;


const TrackFilter = (props) => (
    <Filter {...props} pagination={<TrackPagination />}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput label="Site Name" perPage = {10000}
            sort={{ field: 'name', order: 'ASC' }}
            source="site" reference="sites">
            <AutocompleteInput optionText="name" />
        </ReferenceInput>
        { props.filterValues.site &&
            <ReferenceInput label="Map Image Name" source="overlay"
                sort={{ field: 'name', order: 'ASC' }}
                key={props.filterValues.site}
                reference="overlays" filter={{ track__site: props.filterValues.site}} perPage = {10000}>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
        }
    </Filter>
);

export const TrackList = props => (
    <List {...props} title="Courses List" filters={<TrackFilter />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="title" />
            <TextField source="level" />
            <TextField source="type" />
            <TextField source="description" />
            <TextField label={"For who this course is"} source="for_who" />
            <TextField source="estimated_duration" label={"Estimated Duration"} />
            <TextField source="points_type" label={"Stations Type"} />
            <TextField source="route_max_time" label={"Time Hard limit in minutes"} />
            <TextField source="time_limit" label={"Time Soft limit in minutes"} />
            <TextField source="score_decrease_per_minute" label={"Score decrease per minute"} />
            <TextField source="station_radius" label={"Radius"} />
            <BooleanField source="is_show_my_location_button" label={"Is Show My Location on"} />
            <BooleanField source="is_show_auto_north_button" label={"Is North available"} />
            <BooleanField source="is_show_center_map_button" label={"Is Center Map available"} />
            <BooleanField source="is_show_background_mode_button" label={"Is BackgroundMode available"} />
            <BooleanField source="is_ordered" label={"Is Ordered"} />
            <BooleanField source="is_soft_ordered" label={"Is Soft Ordered"} />
            <BooleanField source="is_silence_mode" label={"Is Silence Mode"} />
            <TextField source="location_frequency" label={"Location Frequency"} />
            <TextField source="location_accuracy" label={"Location Accuracy"} />
            <TextField source="tile_server_url" label={"Tile Server Url"} />
            <ReferenceField source="site" reference="sites" allowEmpty>
                <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Map Image Name" source="overlay" reference="overlays" allowEmpty>
                <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Map Image" source="overlay" reference="overlays" allowEmpty>
                <ImageField source="image" />
            </ReferenceField>
            <EditButton />
            <DeleteButton mutationMode={"pessimistic"} />
            <CloneButton />
        </Datagrid>
    </List>
);

const SoftOrderedEdit = ({ formData, ...rest }) => {
    const form = useForm();
        return (<Fragment>
            <BooleanInput onChange={bo =>  formData.is_ordered ? form.change(REDUX_FORM_NAME, 'is_soft_ordered', false) : null } source="is_ordered" label={"Is Ordered"} />
            <BooleanInput onChange={bo =>  !formData.is_soft_ordered ? form.change(REDUX_FORM_NAME, 'is_ordered', true) : null } source="is_soft_ordered" label={"Is Soft Ordered"} />
        </Fragment>);
}

export const TrackEdit = props => {
    return (
    <Edit title={<TrackTitle />} {...props}>
        <TabbedForm toolbar={<Toolbar alwaysEnableSaveButton={true}/>}>
            <FormTab label="General">
                <TextInput label="Id" source="id" disabled />
                <TextInput source="title" validate={required()} />
                <TextInput multiline source="description" validate={required()} />
                <TextInput source="level" validate={required()} />
                <TextInput source="type" validate={required()} />
                <TextInput multiline source="for_who" label={"For who this course is"} validate={required()} />
                <TextInput source="estimated_duration" label={"Estimated Duration"} validate={required()} />
                <TextInput source="points_type" label={"Stations Type"} validate={required()} />
                <TextInput source="tile_server_url" label={"Tile Server Url"}/>
                <NumberInput source="route_max_time" label={"Time Hard limit in minutes"} validate={required()} />
                <NumberInput source="time_limit" label={"Time Soft limit in minutes"} validate={required()} />
                <NumberInput source="score_decrease_per_minute" label={"Score decrease per minute"} validate={required()} />
                <NumberInput source="station_radius" label={"Radius"} validate={required()} />
                <BooleanInput source="is_show_my_location_button" label={"Is Show My Location on"} validate={required()} />
                <BooleanInput source="is_show_auto_north_button" label={"Is North available"} validate={required()} />
                <BooleanInput source="is_show_center_map_button" label={"Is Center Map available"} validate={required()} />
                <BooleanInput source="is_show_background_mode_button" label={"Is BackgroundMode available"} validate={required()} />
                <BooleanInput source="is_silence_mode" label={"Is Silence Mode"} />
                <FormDataConsumer>
                    {formDataProps => <SoftOrderedEdit {...formDataProps} />}
                </FormDataConsumer>
                <NumberInput source="location_frequency" label={"Location Frequency"} validate={required()} />
                <NumberInput source="location_accuracy" label={"Location Accuracy"} validate={required()} />
            </FormTab>
            <FormTab label="Site">
                <ReferenceInput
                    label="Site" source="site" reference="sites" sort={{ field: 'name', order: 'ASC' }} validate={required()} perPage = {10000}>
                    <AutocompleteInput optionText="name" />
                </ReferenceInput>
            </FormTab>
            <FormTab label="Map Image">
                <ReferenceInput
                    label="Map Image Name" source="overlay" reference="overlays" sort={{ field: 'name', order: 'ASC' }} validate={required()} perPage = {10000}
                    format={(value) => { return (value && value.id) ? value.id : value; }}
                    parse={(value) => {  return value; }}>
                    <AutocompleteInput optionText="name" onChange={(val) => console.log('Autocomplete onChange val:', val)} />
                </ReferenceInput>
                {/* <FormDataConsumer>
                    {({ formData }) => (
                        <pre style={{ background:'#f6f8fa', padding:8 }}>
{JSON.stringify({ overlayFieldValue: formData.overlay, fullFormData: formData }, null, 2)}
                        </pre>
                    )}
                </FormDataConsumer> */}
            </FormTab>
        </TabbedForm>
    </Edit>
);
};

const SoftOrderedCreate = ({ formData, ...rest }) => {
    const form = useForm();
    return (<Fragment>
            <BooleanInput onChange={bo =>  formData.is_ordered ? form.change(REDUX_FORM_NAME, 'is_soft_ordered', false) : null } source="is_ordered" label={"Is Ordered"} />
            <BooleanInput onChange={bo =>  !formData.is_soft_ordered ? form.change(REDUX_FORM_NAME, 'is_ordered', true) : null } source="is_soft_ordered" label={"Is Soft Ordered"} />
        </Fragment>);
    }

export const TrackCreate = props => {
    return (
    <Create {...props}>
        <TabbedForm>
            <FormTab label="Gerneral">
                <TextInput source="title" validate={required()} />
                <TextInput multiline source="description" validate={required()} />
                <TextInput source="level" validate={required()} />
                <TextInput source="type" validate={required()} />
                <TextInput multiline source="for_who" label={"For who this course is"} validate={required()} />
                <TextInput source="estimated_duration" label={"Estimated Duration"} validate={required()} />
                <TextInput source="points_type" label={"Stations Type"} validate={required()} />
                <TextInput source="tile_server_url" label={"Tile Server Url"}/>
                <NumberInput source="route_max_time" label={"Time Hard limit in minutes"} validate={required()} />
                <NumberInput source="time_limit" label={"Time Soft limit in minutes"} validate={required()} />
                <NumberInput source="score_decrease_per_minute" label={"Score decrease per minute"} validate={required()} />
                <NumberInput source="station_radius" label={"Radius"} validate={required()} />
                <BooleanInput source="is_show_my_location_button" label={"Is Show My Location on"} validate={required()} />
                <BooleanInput source="is_show_auto_north_button" label={"Is North available"} validate={required()} />
                <BooleanInput source="is_show_center_map_button" label={"Is Center Map available"} validate={required()} />
                <BooleanInput source="is_show_background_mode_button" label={"Is BackgroundMode available"} validate={required()} />
                <BooleanInput source="is_silence_mode" label={"Is Silence Mode"} />
                <FormDataConsumer>
                    {formDataProps => <SoftOrderedCreate {...formDataProps} />}
                </FormDataConsumer>
                <NumberInput source="location_frequency" label={"Location Frequency"} validate={required()} />
                <NumberInput source="location_accuracy" label={"Location Accuracy"} validate={required()} />
            </FormTab>
            <FormTab label="Site">
                <ReferenceInput label="Site" source="site" reference="sites" sort={{ field: 'name', order: 'ASC' }} validate={required()} perPage = {10000}>
                    <AutocompleteInput optionText="name" />
                </ReferenceInput>
            </FormTab>
            <FormTab label="Map Image">
                <ReferenceInput
                    label="Map Image Name" source="overlay" reference="overlays" sort={{ field: 'name', order: 'ASC' }} validate={required()} perPage = {10000}>
                    <AutocompleteInput optionText="name" />
                </ReferenceInput>
            </FormTab>
        </TabbedForm>
    </Create>
);
                };

const TrackTitle = ({ record }) => {
    return <span>Course {record ? `"${record.title}"` : ''}</span>;
};